import {
  generateSlug,
  getIdFromSlug as extractIdFromSlug,
  isValidMongoId as isValidMongoIdUtil,
} from "@/utils/slug";

interface IGetSlug {
  title: string;
  id: string;
}

/**
 * @deprecated Use generateSlug from @/utils/slug instead
 * Преобразует заголовок в URL-friendly slug
 * @param title Title for transformation
 * @param options Дополнительные опции
 * @returns Slug строка
 */
export const titleToSlug = (
  title: string,
  options?: { lower?: boolean; appendIndex?: number },
) => {
  if (!title) {
    return "";
  }

  // Use new unified helper
  const slug = generateSlug(title, {
    lowercase: options?.lower !== false,
    separator: "-",
  });

  // Add index if specified
  if (options?.appendIndex !== undefined) {
    return `${slug}-${options.appendIndex}`;
  }

  return slug;
};

/**
 * @deprecated Use generateSlug from @/utils/slug instead
 * Генерирует slug для объекта недвижимости используя заголовок и ID
 */
export const getSlug = ({ title, id }: IGetSlug) => {
  if (!title || !id) {
    return "";
  }
  const slug = `${generateSlug(title)}-${id}`;
  return slug;
};

/**
 * @deprecated Use isValidMongoId from @/utils/slug instead
 * Проверяет, представляет ли строка MongoDB ObjectId
 * @param id Строка для проверки
 * @returns Boolean
 */
export const isValidMongoId = (id: string): boolean => {
  return isValidMongoIdUtil(id);
};

/**
 * @deprecated Use getIdFromSlug from @/utils/slug instead
 * Извлекает MongoDB ID из slug, если он присутствует
 * @param slug Входная строка slug
 * @returns MongoDB ID или null, если не найден
 */
export const getIdFromSlug = (slug: string): string | null => {
  return extractIdFromSlug(slug);
};

/**
 * @deprecated Use generateSlug from @/utils/slug instead
 * Legacy function for posts - использует новый хелпер
 */
export const getPostSlug = (post: any): string => {
  if (!post) {
    return "";
  }

  // Try to get title from different possible fields
  const title = post.title || post.name || post.slug || "";

  if (!title) {
    return "";
  }

  // Use new unified helper
  return generateSlug(title);
};
